import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

interface BotCProps {
  onBack: () => void;
}

const BotC: React.FC<BotCProps> = ({ onBack }) => {
  return (
    <div className="min-h-screen p-8 lg:ml-64 lg:mr-80">
      <div className="max-w-full mx-auto">
        {/* Header */}
        <div className="bg-[#f582ae] border-4 border-black p-6 mb-6 shadow-[8px_8px_0px_0px_rgba(0,0,0,1)]">
          <button
            onClick={onBack}
            className="mb-4 bg-black text-[#f582ae] px-4 py-2 border-4 border-black hover:bg-[#8bd3dd] hover:text-black transition-colors font-bold"
          >
            <FontAwesomeIcon icon={faArrowLeft} className="mr-2" />
            Back to Activities
          </button>
          <h1 className="text-4xl font-bold text-black">
            Blood on the Clocktower
          </h1>
          <p className="text-black mt-2 text-lg">
            A social deduction game of murder and mystery
          </p>
        </div>

        {/* Embedded Townsquare */}
        <div className="bg-white border-4 border-black shadow-[8px_8px_0px_0px_rgba(0,0,0,1)] overflow-hidden">
          <iframe
            src="https://clocktower.online"
            style={{
              width: '100%',
              height: 'calc(100vh - 300px)',
              minHeight: '600px',
              border: 'none',
            }}
            title="Blood on the Clocktower - Town Square"
            allowFullScreen
          />
        </div>

        {/* Info Section */}
        <div className="bg-[#8bd3dd] border-4 border-black p-6 mt-6 shadow-[8px_8px_0px_0px_rgba(0,0,0,1)]">
          <h2 className="text-2xl font-bold text-black mb-3">How to Play</h2>
          <ul className="list-disc list-inside text-black space-y-2">
            <li>Click "Start a new Session" to create a game as Storyteller</li>
            <li>Share the session ID with your friends to join</li>
            <li>Add players and assign characters from the Grimoire (press 'G')</li>
            <li>Manage the night phase and voting during the day</li>
            <li>The app is hosted externally at clocktower.online</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default BotC;
